import Vue from "vue";
import Vuex from 'vuex';
import VueCookies from 'vue-cookies';
import PopupModel from "../Components/Common/PopupModel";
import QuickOrderByBarcode from '../Components/Products/QuickOrderByBarcode';
import SmartOrderGrid from '../Components/Products/SmartOrderGrid';
import CustomerBalanceInfo from '../Components/Transactions/CustomerBalanceInfo';

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    order: {}
  },
  getters: {
    getQuantityById: (state) => (id) => {
      let quantity = 0;

      for (let i = 0; i < state.order.OrderLines.length; i++) {
        const orderline = state.order.OrderLines[i];
        const items = orderline.Items;

        for (var j = 0; j < items.length; j++) {
          const item = items[j];
          if (item.ProductIdentifier !== id) continue;

          quantity += item.Quantity * orderline.Quantity;
        }
      }

      return quantity;
    }
  },
  mutations: {
    updateCurrentOrder(state, payload) {
      state.order = payload.order;
      //console.log(state.order);
      //console.log(payload);
    }
  }
});

Vue.use(VueCookies);
Vue.$cookies.config('365d');

Vue.directive('click-outside', {
  priority: 9999,
  bind: function (el, binding, vnode) {
    //console.log("this", this);
    //console.log("el", el);
    //console.log("el.addEventListener", el.addEventListener);
    //console.log("binding", binding);
    //console.log("vnode", vnode);
    el.addEventListener('click', (event) => event.stopPropagation());
    document.body.addEventListener('click', (event) => binding.value());  //vnode.context.$emit(binding.expression)
  },

  unbind: function (el, binding, vnode) {
    el.removeEventListener('click', (event) => event.stopPropagation());
    document.body.removeEventListener('click', (event) => binding.value());
  }
});

Vue.component('popup-model', PopupModel);

const bindCameraFeatures = function (el) {
  const cameraFeaturesItem = new Vue({
    el: `#${el}`,
    data: {
      showCamFeatures: false
    },
    components: { QuickOrderByBarcode }
  });

  return cameraFeaturesItem;
};

const bindSmartOrderGrid = function (el) {
  const smartOrderGrid = new Vue({
    el: `#${el}`,
    store: store,
    components: { SmartOrderGrid }
  });

  return smartOrderGrid;
};

const bindCustomerBalanceInfo = function (el) {
  const customerBalanceInfo = new Vue({
    el: `#${el}`,
    store: store,
    components: { CustomerBalanceInfo }
  });

  return customerBalanceInfo;
};

export {
  store,
  bindCameraFeatures, bindSmartOrderGrid, bindCustomerBalanceInfo
};




// WEBPACK FOOTER //
// ./EcomCore/Scripts/App.js